const API_URL = import.meta.env.VITE_API_URL || 'http://localhost:3000';

export const fetchEdificios = async ({ limit = 100, offset = 1, query = {} } = {}) => {
  try {
    const response = await fetch(`${API_URL}/edificios/filter`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ limit, offset, query }),
    });

    if (!response.ok) {
      throw new Error('Error al obtener los edificios');
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Error al obtener los edificios:', error);
    throw error;
  }
};

export const fetchEdificioById = async (id) => {
  try {
    const response = await fetch(`${API_URL}/edificios/${id}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    });

    if (!response.ok) {
      throw new Error('Error al obtener el edificio');
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Error al obtener el edificio:', error);
    throw error;
  }
};

export const createEdificio = async (edificioData) => {
  try {
    const response = await fetch(`${API_URL}/edificios/create`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(edificioData),
    });

    if (!response.ok) {
      throw new Error('Error al crear el edificio');
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Error al crear el edificio:', error);
    throw error;
  }
};

export const updateEdificio = async (id, edificioData) => {
  try {
    const response = await fetch(`${API_URL}/edificios/update/${id}`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(edificioData),
    });

    if (!response.ok) {
      throw new Error('Error al actualizar el edificio');
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Error al actualizar el edificio:', error);
    throw error;
  }
};

export const deleteEdificio = async (id) => {
  try {
    const response = await fetch(`${API_URL}/edificios/delete/${id}`, {
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json',
      },
    });

    if (!response.ok) {
      throw new Error('Error al eliminar el edificio');
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Error al eliminar el edificio:', error);
    throw error;
  }
};
